/** How long a film may take to be read before it counts as one this browser cannot play. */
const FILM_FACTS_MS = 10_000

/** A film's length and a still frame from its first second, read by this browser; zero and none when it cannot play it. */
export function filmFacts(file: File): Promise<{ durationMs: number; poster?: Blob }> {
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file)
    const video = document.createElement('video')
    video.muted = true
    video.preload = 'auto'
    let settled = false
    const done = (facts: { durationMs: number; poster?: Blob }) => {
      if (settled) return
      settled = true
      window.clearTimeout(timer)
      video.onerror = video.onloadedmetadata = video.onseeked = null
      video.removeAttribute('src')
      video.load()
      URL.revokeObjectURL(url)
      resolve(facts)
    }
    const timer = window.setTimeout(() => done({ durationMs: 0 }), FILM_FACTS_MS)
    video.onerror = () => done({ durationMs: 0 })
    video.onloadedmetadata = () => {
      video.currentTime = Math.min(1, (Number.isFinite(video.duration) ? video.duration : 0) / 2)
    }
    video.onseeked = () => {
      const durationMs = Number.isFinite(video.duration) ? Math.round(video.duration * 1000) : 0
      const width = video.videoWidth || 480
      const scale = Math.min(1, 480 / width)
      const canvas = document.createElement('canvas')
      canvas.width = Math.round(width * scale)
      canvas.height = Math.round((video.videoHeight || 270) * scale)
      canvas.getContext('2d')?.drawImage(video, 0, 0, canvas.width, canvas.height)
      canvas.toBlob((blob) => done(blob ? { durationMs, poster: blob } : { durationMs }), 'image/jpeg', 0.8)
    }
    video.src = url
  })
}
